import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: {
        position: "absolute",
        backgroundColor: '#0f3362',
        width: "100%",
        height: "100%",
    },
    container: {
        backgroundColor: "white",
        borderRadius: '8px',
        maxWidth: '380px'
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    submit: {
        margin: theme.spacing(4, 0, 3),
        lineHeight: '2.45'
    },
    textField: {
        marginBlockEnd: '22px',
        minWidth: "200px",
    },
    progress: {
        marginLeft: "auto",
        marginRight: 'auto',
        paddingLeft: '20px',
        paddingRight: '20px'
    },
}));

export default useStyles;
